module.exports = __webpack_public_path__ + "static/media/hxjfgz.7035a872.png";